import * as React from 'react';
import Helmet from '../../commonComponents/Helmet';
import PageTitle from '../common/PageTitle';
import { LoginLogo } from './logos';
import { Logo } from '../../models/be/Branding';
import './AnonymousHeader.less';

const AnonymousHeader = (props: Props) => (
	<header className={`anonymousHeader${props.stacked ? ' stacked' : ''}`}>
		<LoginLogo logo={props.logo} />
		{props.title && (props.renderHeading ? <PageTitle title={props.title} /> : <Helmet title={props.title} />)}
	</header>
);

interface Props {
	title: string;
	renderHeading: boolean;
	stacked?: boolean;
	logo?: Logo;
}

AnonymousHeader.defaultProps = {
	stacked: false,
	logo: null
};

export default AnonymousHeader;
